import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { login, restoreSession, restoreRole, logout } from "./actions";
import { CssBaseline } from "@mui/material";
import Reception from "./pages/Reception";
import AutoReception from "./pages/AutoReception";
import GuestsManage from "./pages/GuestsManage";
import PaymentUrlManage from "./pages/PaymentUrlManage";
import Invitation from "./pages/invitation/Invitation";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import StickyHeadTable from "./pages/TableTest";
import Pamphlet from "./pages/invitation/Pamphlet";
import InvalidInvitation from "./pages/Invalid";
import History from "./pages/History";

function App() {
  const dispatch = useDispatch();
  const error = useSelector((state) => state.error);
  const isAuthenticated = useSelector((state) => state.isAuthenticated);
  const role = useSelector((state) => state.role);

  useEffect(() => {
    const checkTokenExpiration = () => {
      const savedToken = localStorage.getItem("token");
      const savedRole = localStorage.getItem("role");
      const tokenExpiration = localStorage.getItem("expirationTime");

      if (savedToken && savedRole) {
        dispatch(restoreSession(savedToken)); // トークンがあればセッション復元
        dispatch(restoreRole(savedRole)); // ロール情報も復元
      }

      if (
        savedToken &&
        tokenExpiration &&
        new Date().getTime() > tokenExpiration
      ) {
        console.log("Token expired.");
        dispatch(logout());
      }
    };

    const handleStorageChange = (event) => {
      if (
        event.key === "token" ||
        event.key === "role" ||
        event.key === "expirationTime"
      ) {
        checkTokenExpiration();
        const savedToken = localStorage.getItem("token");
        const savedRole = localStorage.getItem("role");
        if (!savedToken || !savedRole) {
          // dispatch(logout());
        } else {
          console.log("Token exists.");
          // dispatch(login());
          dispatch(restoreSession(savedToken));
          dispatch(restoreRole(savedRole));
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    const intervalId = setInterval(checkTokenExpiration, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(intervalId);
    };
  }, [dispatch]);

  return (
    <Router>
      <InnerApp isAuthenticated={isAuthenticated} />
    </Router>
  );
}

const InnerApp = ({ isAuthenticated }) => {
  const location = useLocation();

  const noNavbarPaths = ["/host/login", "/guest"];
  const showNavbar =
    isAuthenticated &&
    !noNavbarPaths.includes(location.pathname) &&
    !location.pathname.startsWith("/guest/");

  if (location.pathname.startsWith("/host/")) {
    require("./Host.scss");
  } else if (location.pathname.startsWith("/guest/")) {
    require("./Guest.scss");
  }

  const noThemePaths = location.pathname.startsWith("/guest");

  return (
    <>
      {!noThemePaths ? (
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/host/login" element={<Login />} />
            <Route
              path="/host/reception"
              element={
                isAuthenticated ? <Reception /> : <Navigate to="/host/login" />
              }
            />
            <Route
              path="/host/reception/auto"
              element={
                isAuthenticated ? (
                  <AutoReception />
                ) : (
                  <Navigate to="/host/login" />
                )
              }
            />
            <Route
              path="/host/guest-manage"
              element={
                isAuthenticated ? (
                  <GuestsManage />
                ) : (
                  <Navigate to="/host/login" />
                )
              }
            />
            <Route
              path="/host/history"
              element={
                isAuthenticated ? <History /> : <Navigate to="/host/login" />
              }
            />
            <Route
              path="/host/payment-url"
              element={
                isAuthenticated ? (
                  <PaymentUrlManage />
                ) : (
                  <Navigate to="/host/login" />
                )
              }
            />
            <Route path="/host/logout" element={<Logout />} />
            <Route path="/" element={<Navigate to="/host/login" />} />
          </Routes>
        </ThemeProvider>
      ) : (
        <Routes>
          <Route path="/guest/invitation" element={<Invitation />} />
          <Route path="/guest/invitation/:id" element={<Invitation />} />
          <Route path="/guest/pamphlet/:id" element={<Pamphlet />} />
          <Route path="/guest/invalid" element={<InvalidInvitation />} />
        </Routes>
      )}
    </>
  );
};

export default App;
